export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('table_label_operation') || '操作',
    field: 'col-opt',
    align: 'center',
    fixed: 'right',
    width: 80,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_userName') || '姓名',
    field: 'userName',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_userNo') || '工号',
    field: 'userNo',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
  },
]
